module.exports = __webpack_public_path__ + "img/kinderflamme.c7f89fd7.jpg";